import { render, staticRenderFns } from "./new.vue?vue&type=template&id=05e7df3a&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e7df3a')) {
      api.createRecord('05e7df3a', component.options)
    } else {
      api.reload('05e7df3a', component.options)
    }
    module.hot.accept("./new.vue?vue&type=template&id=05e7df3a&", function () {
      api.rerender('05e7df3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/permission/new.vue"
export default component.exports